// src/pages/About/index.jsx
import { Card, Typography } from 'antd';

const { Title, Paragraph } = Typography;

const About = () => {
  return (
    <div style={{ padding: 24 }}>
      <Card>
        <Title level={2}>关于我们</Title>
        <Paragraph>
          这是一个技术博客网站，致力于分享编程知识和技术经验。
        </Paragraph>
        
        <Title level={3}>网站目标</Title>
        <Paragraph>
          为开发者提供一个学习和交流的平台，分享前端、后端、移动端等各领域的技术文章。
        </Paragraph>
        
        <Title level={3}>主要内容</Title>
        <Paragraph>
          • 技术教程<br/>
          • 开发经验<br/>
          • 项目实践<br/>
          • 学习心得<br/>
          • 行业动态
        </Paragraph>
        
        <Title level={3}>联系方式</Title>
        <Paragraph>
          邮箱：contact@example.com<br/>
          地址：XX市XX区XX街道
        </Paragraph>
      </Card>
    </div>
  );
};

export default About;